// extracted by mini-css-extract-plugin
export default {"aboutNewBtn":"NewButton_aboutNewBtn__WTHjf","visible":"NewButton_visible__fbT22","unvisible":"NewButton_unvisible__7NaiE"};